import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  locale:
    typeof window !== "undefined" && sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang").toLocaleLowerCase()
      : "id",
  language:
    typeof window !== "undefined" && sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang").toLocaleLowerCase()
      : "id",
}

const intlSlice = createSlice({
  name: "intl",
  initialState,
  reducers: {
    setLocale: (state, action) => {
      state.locale = action.payload
    },
    setLanguage: (state, action) => {
      state.language = action.payload
    },
  },
})

export const { setLanguage, setLocale } = intlSlice.actions
export default intlSlice.reducer
